import { render, staticRenderFns } from "./ChartScale.vue?vue&type=template&id=912bfb84&"
import script from "./ChartScale.vue?vue&type=script&lang=js&"
export * from "./ChartScale.vue?vue&type=script&lang=js&"
import style0 from "./ChartScale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports